import { createSignal, onMount } from "solid-js";
import { sfetchStandalone } from "../hooks/sfetch";
import { firstError } from "../api/envelope";
import styles from "./MSLogin.module.css";
import Text from "../components/Text";

export function MSLoginPage() {
  const [status, setStatus] = createSignal("PROCESSING");
  const [error, setError] = createSignal<string | null>(null);

  const [redirectUri, setRedirectUri] = createSignal<string>("/me");

  function getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
    return null;
  }

  onMount(async () => {

    setTimeout(() => {
      let spinner = document.getElementById("spinner");
      if (spinner) {
        spinner.setAttribute("src", "/MS LoginLoop.svg");
      }
    }, 2000);

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    const state = params.get("state");
    let backendState: string | null = null;
    if (state) {
      const storedState = getCookie(state);
      if (!storedState) {
        setStatus("ERROR");
        setError("INVALID_STATE");
        return;
      }

      const json = JSON.parse(decodeURIComponent(storedState));
      setRedirectUri(json.next);
      backendState = json.backendState || null;
    }

    if (!code) {
      setStatus("ERROR");
      setError("NO_CODE_PROVIDED");
      return;
    }

    try {
      const result = await sfetchStandalone(`/api/oauth/ms/callback`, {
        method: "POST",
        body: JSON.stringify({ code, state: backendState })
      });

      setTimeout(() => {
        if (result.ok) {
          setStatus("SUCCESS");
          let spinner = document.getElementById("spinner");
          if (spinner) {
            spinner.setAttribute("src", "/MS LoginEnd.svg");
          }
          const target = result.botLinked ? "/botengine?linked=true" : redirectUri();
          setTimeout(() => document.location = target, 3000);
        } else {
          setStatus("ERROR");
          setError(firstError(result) ?? result.message ?? "LOGIN_FAILED");
        }
      }, 2000);
    } catch (err) {
      setStatus("ERROR");
      setError("NETWORK_ERROR");
    }
  });

  return (
    <div class={styles.container}>
      <div class={styles.card}>
        <div class={styles.header}>
          <div class={styles.logo}>
            <i class={`fa-brands fa-microsoft ${styles.logoIcon}`}></i>
          </div>
          <h1 class={styles.title}><Text val="MS_LOGIN_TITLE" /></h1>
          <p class={styles.subtitle}><Text val="MS_LOGIN_SUBTITLE" /></p>
        </div>

        <div class={styles.content}>
          {(status() === "PROCESSING" || status() === "SUCCESS") && (
            <>
              <p class={styles.message}><Text val={status() === "PROCESSING" ? "MS_LOGIN_PROCESSING" : "MS_LOGIN_SUCCESS"} /></p>
              <img id="spinner" src="/MS Login.svg"></img>
            </>
          )}
          
          {status() === "ERROR" && (
            <>
              <div class={`${styles.statusIcon} ${styles.errorIcon}`}>
                <i class="fa fa-times"></i>
              </div>
              <p class={`${styles.message} ${styles.errorMessage}`}>
                <Text val="MS_LOGIN_ERROR" />
              </p>
              <div class={styles.errorDetails}>
                <Text val={error() || "UNKNOWN_ERROR"} />
              </div>
            </>
          )}
        </div>

        <div class={styles.footer}>
          <Text val="MS_LOGIN_FOOTER" />
        </div>
      </div>
    </div>
  );
}
